import { FC } from "react";

import {
  AdditionValueTemplate,
  AreaAdditions,
  AreaWaypointsTemplate,
  BooleanImageIconTemplate,
  CatchARideAvailabilityTemplate,
  CheckboxTemplate,
  ColorPickerTemplate,
  CustomTranslationsTemplate,
  DataUploadRunSummaryTemplate,
  DateCountdownReadonlyTemplate,
  DateTemplate,
  DateTimeTemplate,
  DistanceAdditions,
  DropdownBoundTemplate,
  DropdownTemplate,
  EmailTemplate,
  GroupTitleTemplate,
  HiddenFieldTemplate,
  HtmlInfoTemplate,
  HubStationStandaloneTemplate,
  HubStationTemplate,
  IdLabelTemplate,
  JSONSmartViewerTemplate,
  LinkToAnotherEntityGridFilteredByCurrentTemplate,
  LinkToEditCardTemplate,
  MultiselectBoundTemplate,
  MultiselectTemplate,
  NeighborAreasTemplate,
  NotificationContentTemplate,
  NotificationIsReadTemplate,
  NumberTemplate,
  OpenEntityFormTemplated,
  PassengerAdditions,
  PassengerAddressTemplate,
  PasswordTemplate,
  PhoneTemplate,
  PriceRateAdditionPricing,
  ProductionChainTemplate,
  RadioGroupTemplate,
  RecurringProductionTemplate,
  ResetPasswordButtonTemplate,
  RideNestedGridTemplate,
  SectionTitleTemplate,
  ShiftCycleTemplate,
  SiteDropdownBoundTemplate,
  StationAdditions,
  SwitchTemplate,
  TableAvailabilityTemplate,
  TableContactsTemplate,
  TableRatiosTemplate,
  TableRouteScheduleTemplate,
  TableStationHubTemplate,
  TableUserRolesTemplate,
  TagsTemplate,
  TextareaTemplate,
  TextboxTemplate,
  TimeTemplate,
  TimeZoneDropdownTemplate,
  TrafficAvailabilityTemplate,
  UrlTemplate,
} from "@ryde/controls";
import { FORM_FIELD_KEYS, ICustomField } from "@ryde/shared";

import {
  AddressTemplate,
  GeoJsonPolygonTemplate,
  MapBoundsTemplate,
  StationDropdownBoundTemplate,
} from "../templates";

export const fieldNameToField: Record<FORM_FIELD_KEYS, FC<ICustomField>> = {
  address: AddressTemplate,
  passenger_address: PassengerAddressTemplate,
  checkbox: CheckboxTemplate,
  currency: NumberTemplate,
  date: DateTemplate,
  date_range: TextboxTemplate,
  datetime: DateTimeTemplate,
  datetime_range: TextboxTemplate,
  dropdown: DropdownTemplate,
  dropdown_bound: DropdownBoundTemplate,
  email: EmailTemplate,
  group_title: GroupTitleTemplate,
  section_title: SectionTitleTemplate,
  id_label: IdLabelTemplate,
  map_bounds: MapBoundsTemplate,
  map_polygon: GeoJsonPolygonTemplate,
  multiselect: MultiselectTemplate,
  multiselect_bound: MultiselectBoundTemplate,
  number: NumberTemplate,
  password: PasswordTemplate,
  phone: PhoneTemplate,
  price_rate_areas_pricing: AreaAdditions,
  price_rate_distance_pricing: DistanceAdditions,
  price_rate_passengers_pricing: PassengerAdditions,
  price_rate_stations_pricing: StationAdditions,
  price_rate_addition_pricing_level: PriceRateAdditionPricing,
  relation_counters: TextboxTemplate,
  shift_template_cycle: ShiftCycleTemplate,
  switch: SwitchTemplate,
  table_area_ratios: TableRatiosTemplate,
  table_contacts: TableContactsTemplate,
  table_integrations: TextboxTemplate,
  table_user_roles: TableUserRolesTemplate,
  table_time_schedule: TableRouteScheduleTemplate,
  tags: TagsTemplate,
  text: TextboxTemplate,
  textarea: TextareaTemplate,
  time: TimeTemplate,
  time_range: TextboxTemplate,
  url: UrlTemplate,
  addition_value: AdditionValueTemplate,
  area_waypoints: AreaWaypointsTemplate,
  boolean_image_icon: BooleanImageIconTemplate,
  table_availability: TableAvailabilityTemplate,
  table_station_hub: TableStationHubTemplate,
  station_dropdown: StationDropdownBoundTemplate,
  site_dropdown: SiteDropdownBoundTemplate,
  radio_group: RadioGroupTemplate,
  html_info: HtmlInfoTemplate,
  notification_read: NotificationIsReadTemplate,
  notification_content: NotificationContentTemplate,
  date_countdown_readonly: DateCountdownReadonlyTemplate,
  link_to_another_entity_grid_filtered_by_current:
    LinkToAnotherEntityGridFilteredByCurrentTemplate,
  link_to_entity_card: LinkToEditCardTemplate,
  open_entity_form: OpenEntityFormTemplated,
  timezone_dropdown: TimeZoneDropdownTemplate,
  neighbor_areas: NeighborAreasTemplate,
  reset_password_system_manager: ResetPasswordButtonTemplate,
  custom_translations: CustomTranslationsTemplate,
  traffic_availability: TrafficAvailabilityTemplate,
  rides_nested_grid: RideNestedGridTemplate,
  data_upload_run_summary: DataUploadRunSummaryTemplate,
  hidden_field: HiddenFieldTemplate, // Placeholder for hidden fields, no UI component needed
  hub_station_template: HubStationTemplate,
  hub_station_standalone_template: HubStationStandaloneTemplate,
  recurring_production: RecurringProductionTemplate,
  production_chain: ProductionChainTemplate,
  color_picker: ColorPickerTemplate,
  json_viewer: JSONSmartViewerTemplate,
  catch_a_ride_availability: CatchARideAvailabilityTemplate,
};
